import { Injectable } from '@angular/core';
import { SignalStoreService } from './signal-store.service';
import { User } from '../types/user';

@Injectable()
export class UserStateService extends SignalStoreService<User> {
    constructor() {
        super();
    }
}
